module.exports = __webpack_public_path__ + "img/wawa_slide_2.abe4cdc5.jpg";